export default function U1({ content, path }) {
  return (
    <a
      className=" text-c11 font-bold underline || h-c18 "
      href={path}
      target="_blank"
    >
      {content}
    </a>
  );
}
